module.exports = __webpack_public_path__ + "static/media/medkit.af9003f9.svg";